import * as React from "react";
import "./text-input.css";

export enum TextInputMode {
  PASSWORD = "password",
  EMAIL = "email",
  PLAIN_TEXT = "text",
  NUMBER = "number",
}

export enum TextAlignment {
  CENTER = "center",
  LEFT = "left",
  RIGHT = "right",
}

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  mode?: TextInputMode;
  textAlignment?: TextAlignment;
  label?: string;
}

export const TextInput: React.FC<TextInputProps> = ({
  id,
  textAlignment = TextAlignment.LEFT,
  mode = TextInputMode.PLAIN_TEXT,
  label,
  placeholder,
  className,
  onChange,
  value,
  ...rest
}) => {
  if (label && !id) {
    console.warn("Inputs with labels should assign ids for accessibility");
  }
  return (
    <div className="TextInput">
      <input
        {...rest}
        id={id}
        className={`TextInput-input ${className}`}
        style={{ textAlign: textAlignment }}
        type={mode}
        placeholder={placeholder || label}
        value={value}
        min="1"
        onChange={onChange}
      />
      {label && (
        <label className="TextInput-label" htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
};
